'use strict';

module.exports = 'enhanceString';


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/var/STRING_ENHANCEMENTS_FLAG.js
// module id = 948
// module chunks = 0